<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Στοιχεία Φορέα</h4>
            <p class="card-title-desc">
              Φόρμα με στοιχεία του Φορέα
            </p>
            <b-alert
              v-show="alert.alertShow"
              show
              dismissible
              :variant="alert.alertVariant"
            >{{ alert.alertMsg
            }}</b-alert>

            <div class="row">
              <div class="col-12">
                <form
                  class="form-horizontal"
                  role="form"
                  @submit.prevent="industryFormSubmit"
                >
                  <b-form-group
                    class="mb-3"
                    id="example text"
                    label-cols-lg="2"
                    label="Όνομασία Φορέα:"
                    label-for="text"
                  >
                    <b-form-input
                      v-model="industry.name"
                      for="text"
                      placeholder="Όνομα Φορέα"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    id="example-search"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Διεύθυνση:"
                    label-for="address"
                  >
                    <b-form-input
                      id="address"
                      value=""
                      placeholder="Διεύθυνση"
                      type="text"
                      name="address"
                      v-model="industry.address"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    id="example-search"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="ΑΦΜ:"
                    label-for="afm"
                  >
                    <b-form-input
                      id="afm"
                      v-model="industry.afm"
                      placeholder="ΑΦΜ"
                      type="text"
                      name="afm"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    id="example-tel"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Τηλέφωνο:"
                    label-for="tele"
                  >
                    <b-form-input
                      placeholder="Τηλέφωνο"
                      id="tele"
                      v-model="industry.telephone"
                      type="tel"
                      name="tel"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    id="example-time"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Έναρξη ωραρίου:"
                    label-for="time"
                  >
                    <!-- <b-form-input
                      id="time"
                      v-model="industry.start_time"
                      type="time"
                    ></b-form-input> -->
                    <date-picker
                      v-model="industry.start_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      placeholder="HH:mm"
                    ></date-picker>
                  </b-form-group>
                  <b-form-group
                    class="mb-3"
                    id="example-time"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Λήξη ωραρίου:"
                    label-for="time"
                  >
                    <!-- <b-form-input
                      id="time"
                      v-model="industry.end_time"
                      type="time"
                    ></b-form-input> -->
                    <date-picker
                      v-model="industry.end_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      placeholder="HH:mm"
                    ></date-picker>
                  </b-form-group>

                  <b-form-group
                    class="mb-3"
                    id="example-time"
                    label-cols-sm="2"
                    label-cols-lg="2"
                    label="Λογότυπο:"
                    label-for="time"
                  >
                    <input
                      class="form-control"
                      type="file"
                      id="formFile"
                      ref="file"
                      accept="image/png, image/jpeg, image/bmp"
                    />
                    <p v-if="industry.image">
                      Προεπιλεγμένη εικόνα :
                      <a
                        :href="industry.image"
                        target="_blank"
                      >{{
                        parseImageUrl(industry.image)
                      }}</a>
                    </p>
                  </b-form-group>
                  <div v-if="is_superuser">
                    <b-form-group
                      class="mb-3"
                      id="example-checkbox"
                      label-cols-sm="2"
                      label-cols-lg="2"
                      label="Ενεργοποίηση Holiday Module:"
                      label-for="time"
                    >
                      <b-form-checkbox
                        v-model="industry.has_holiday_module"
                        value=true
                        unchecked-value=false
                        class="mb-3 custom-checkbox"
                        plain
                      >
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      class="mb-3"
                      id="example-checkbox"
                      label-cols-sm="2"
                      label-cols-lg="2"
                      label="Παράκαμψη Δεντρικής Ιεραρχίας:"
                      label-for="time"
                    >
                      <b-form-checkbox
                        v-model="industry.has_entity_groups"
                        value=true
                        unchecked-value=false
                        class="mb-3 custom-checkbox"
                        plain
                      >
                      </b-form-checkbox>
                    </b-form-group>

                  </div>
                  <b-button
                    variant="primary"
                    type="submit"
                  >Αποθήκευση</b-button>
                </form>
              </div>
            </div>

            <!-- end row -->
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../api/session";
import DatePicker from "vue2-datepicker";
import { eventCreate } from "../../../eventspy.js";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  page: {
    title: "Επεξεργασία Φορέα",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      title: "Επεξεργασια Φορεα",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Φορέας",
          active: true,
        },
      ],
      industry: {
        image: null,
        name: "",
        address: "",
        afm: "",
        telephone: "",
        start_time: "",
        end_time: null,
        has_entity_groups: null,
        has_holiday_module: null,
      },
      alert: {
        alertMsg: "",
        alertVariant: "",
        alertShow: false,
      },
    };
  },
  mounted() {
    this.fetchIndustry();
  },
  computed: {
    ...mapGetters({ is_superuser: "auth/is_superuser" }),
  },
  methods: {
    parseImageUrl(imageUrl) {
      return decodeURI(imageUrl).split("/").slice(-1)[0];
    },
    async fetchIndustry() {
      await session.get("api/industry/retrieve/").then((resp) => {
        if (resp.data.length > 0) {
          this.industry = resp.data[0];
        }
      });
    },

    industryFormSubmit() {
      if (this.industry.id) {
        this.updateIndustry();
      } else {
        this.createIndustry();
      }
    },
    async createIndustry() {
      const formIndustryData = this.parseFormIndustryData();
      await session
        .post("api/industry/create/", formIndustryData, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.alert.alertShow = true;
          this.alert.alertVariant = "success";
          this.alert.alertMsg = "Ανανεώθηκε επιτυχώς";
          this.fetchIndustry();
          this.$store.dispatch("utils/fetchIndystryData");
        })
        .catch((error) => {
          this.alertVariant = "danger";
          this.alertMsg = `Υπήρξε πρόβλημα με ${Object.keys(
            error.response.data
          )} - ${Object.values(error.response.data)}`;
        });

      setTimeout(() => {
        this.alert.alertShow = false;
        this.alert.alertMsg = "";
        this.alert.alertVariant = "";
      }, 2000);
    },
    async updateIndustry() {
      const formIndustryData = this.parseFormIndustryData();
      await session
        .put(`api/industry/${this.industry.id}/update/`, formIndustryData, {
          headers: { "Content-Type": "application/json" },
        })

        .then((resp) => {
          this.alert.alertShow = true;
          this.alert.alertVariant = "success";
          this.alert.alertMsg = "Ανανεώθηκε επιτυχώς";

          eventCreate(
            `Επεξεργασία Φορέα ${JSON.stringify(this.industry)}
              -----------------------------------------
              ${JSON.stringify(resp.data)}`,
            2
          );
          this.fetchIndustry();
        })
        .catch((error) => {
          this.alertVariant = "danger";
          this.alertMsg = `Υπήρξε πρόβλημα με ${Object.keys(
            error.response.data
          )} - ${Object.values(error.response.data)}`;
        });

      await this.$store.dispatch("auth/getIndustry");
      await this.$store.dispatch("auth/getEntity");

      await this.$store.dispatch("utils/fetchIndystryData");

      setTimeout(() => {
        this.alert.alertShow = false;
        this.alert.alertMsg = "";
        this.alert.alertVariant = "";
      }, 2000);
    },
    parseFormIndustryData() {
      let industryForm = new FormData();
      industryForm.append(
        "name",
        this.industry.name == null ? "" : this.industry.name
      );
      industryForm.append(
        "address",
        this.industry.address == null ? "" : this.industry.address
      );
      industryForm.append(
        "afm",
        this.industry.afm == null ? "" : this.industry.afm
      );
      industryForm.append(
        "start_time",
        this.industry.start_time == null ? "" : this.industry.start_time
      );
      industryForm.append(
        "end_time",
        this.industry.end_time == null ? "" : this.industry.end_time
      );
      industryForm.append(
        "telephone",
        this.industry.telephone == null ? "" : this.industry.telephone
      );
      industryForm.append(
        "has_holiday_module",
        this.industry.has_holiday_module == null
          ? ""
          : this.industry.has_holiday_module
      );
      industryForm.append(
        "has_entity_groups",
        this.industry.has_entity_groups == null
          ? ""
          : this.industry.has_entity_groups
      );
      if (this.$refs.file.files[0]) {
        industryForm.append("image", this.$refs.file.files[0]);
      }
      return industryForm;
    },
  },
};
</script>

<style scoped>
::v-deep .custom-checkbox .form-check-input {
  width: 30px;
  height: 30px;
}
</style>
